import React from "react";
import { useForm } from "react-hook-form";
import { Form, FormActions, FormDropdown, FormFields, FormTextField, mapToDropdownOption } from "sprint-common-web";

import { useCreateSigniantDeliveryEndpointForm } from "./useCreateSigniantDeliveryEndpointForm";

export interface CreateDeliveryEndpointFormProps {
    onCancel(): void;
    onSubmit(): void;
}

export interface CreateDeliveryEndpointFormInputs {
    name: string;
    profileId: string;
    distributionEmail: string;
}

export const CreateSigniantDeliveryEndpointForm: React.VFC<CreateDeliveryEndpointFormProps> = ({
    onSubmit,
    onCancel
}: CreateDeliveryEndpointFormProps) => {
    const { addDeliveryEndpoint, storageProfiles, isLoading } = useCreateSigniantDeliveryEndpointForm();

    const { errors, control, formState, handleSubmit, reset } = useForm<CreateDeliveryEndpointFormInputs>({
        defaultValues: {
            name: "",
            profileId: "",
            distributionEmail: ""
        },
        criteriaMode: "all"
    });

    const handleCreateDeliveryEndpoint = async (inputs: CreateDeliveryEndpointFormInputs) => {
        await addDeliveryEndpoint(inputs);
        onSubmit();
    };

    const handleCancelButtonClick = () => {
        reset();
        onCancel();
    };

    return (
        <Form onSubmit={handleSubmit(handleCreateDeliveryEndpoint)}>
            <FormFields>
                <FormTextField
                    label="Name"
                    control={control}
                    name="name"
                    errors={errors}
                    rules={{ required: "Enter name" }}
                />
                <FormDropdown
                    label="Profile"
                    name="profileId"
                    options={storageProfiles.map((item) => mapToDropdownOption(item))}
                    control={control}
                    errors={errors}
                    rules={{ required: "Select storage profile" }}
                />
                <FormTextField
                    label="Distribution Email"
                    control={control}
                    name="distributionEmail"
                    errors={errors}
                    rules={{ required: "Enter distribution email" }}
                />
            </FormFields>
            <FormActions
                isLoading={formState.isSubmitting || formState.isValidating}
                onCancel={handleCancelButtonClick}
            />
        </Form>
    );
};
